import {colors} from 'shells/colors/colors';
import {TargetRegularIcon} from 'shells/icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './sales-quotas-empty-state.module.css';

export function SalesQuotasEmptyState() {
    return (
        <div className={styles.container}>
            <Stack spacing={16} justifyContent='center' alignItems='center'>
                <div className={styles['icon-container']}>
                    {/* @ts-expect-error */}
                    <TargetRegularIcon size={57} color={colors.greenDk} />
                </div>
                <Body isBold={true}>No quotas set yet</Body>
                <Body size='small'>
                    Create your first quota to get started. Once set up, you’ll be able to copy and
                    reuse quotas for other users.
                </Body>
            </Stack>
        </div>
    );
}
